export function ApplyContext(props: {
  contexts: Array<(c: { children: JSX.Element }) => JSX.Element>
  children: JSX.Element
}) {
  return props.contexts.reduce((children, Component) => <Component>{children}</Component>, props.children);
}
